import {Dialog, DialogTitle} from '@material-ui/core'
import {useEffect, useState} from 'react'
import Action from 'src/models/Action'
import Autocomplete, {DataType} from '../Autocomplete'
import {ButtonCancel, ButtonSave, ButtonsBox, DialogRoot} from './styled'

export type ActionsDialogProps = {
  open: boolean
  allActions: Action[]
  selectedActions: Action[]
  onClose: (actions: Action[] | undefined) => void
}

const ActionsDialog: React.FC<ActionsDialogProps> = ({
  open,
  allActions,
  selectedActions,
  onClose,
}: ActionsDialogProps) => {
  const [allActionDataType, setAllActionDataType] = useState<DataType[]>([])
  const [selectedDataType, setSelectedDatatype] = useState<DataType[] | undefined>([])

  // Called when the user clicks "save" to save the set of actions.
  const onSaveClick = () => {
    // Need to make up the list of selected actions.
    const newSelectedActions: Action[] = []
    if (selectedDataType) {
      selectedDataType.forEach((singleSelect) => {
        // Find the action with this ID.
        const action = allActions.find((foundAction) => foundAction.id === singleSelect.id)
        if (action) {
          newSelectedActions.push(action)
        }
      })
      onClose(newSelectedActions)
    } else {
      onClose([])
    }
  }

  ///
  /// This makes an array of DataType for the autocomplete of all currently selected actions..
  ///
  useEffect(() => {
    const dataType: DataType[] = []
    selectedActions.forEach((action) => {
      if (action.id) {
        dataType.push({id: action.id, name: action.title})
      }
    })
    setSelectedDatatype(dataType)
  }, [selectedActions])

  ///
  /// This makes an array of DataType for the autocomplete of all actions.
  ///
  useEffect(() => {
    const dataType: DataType[] = []
    allActions.forEach((action) => {
      if (action.id) {
        dataType.push({id: action.id, name: action.title})
      }
    })
    setAllActionDataType(dataType)
  }, [allActions])

  return (
    <Dialog open={open} maxWidth="lg" fullWidth={true}>
      <DialogTitle>Select Actions</DialogTitle>
      <DialogRoot>
        <Autocomplete
          id="actions"
          title="Actions making up the routine"
          placeholderText="Select actions"
          value={selectedDataType}
          data={allActionDataType}
          multiple
          onChange={(newActions) => setSelectedDatatype(newActions as DataType[])}
        />

        <ButtonsBox display="flex" flexDirection="row-reverse">
          <ButtonSave
            onClick={() => {
              onSaveClick()
            }}>
            Save
          </ButtonSave>
          <ButtonCancel
            onClick={() => {
              onClose(undefined)
            }}
            color="secondary">
            Cancel
          </ButtonCancel>
        </ButtonsBox>
      </DialogRoot>
    </Dialog>
  )
}

export default ActionsDialog
